import React from 'react';

import { constants } from '../../../common/Localization';
import { ColumnDefinition, ColumnTypes } from '../../../common/table/types';
import { formatCell, formatData } from './CellFormatter';
import { CashflowRow } from './MainframeTypes';

export function getMainframeCashflowCostColumnDefinitions(duration: number): ColumnDefinition<CashflowRow>[] {
    const yearCols = new Array(duration).fill(0).map((_, year: number): ColumnDefinition<CashflowRow> => ({
        data: item => formatData(item.cashflowValues[year], item.format, item.currency),
        cell: item => formatCell(item.cashflowValues[year], item.format, item.currency),
        header: `${constants.YEAR} ${year + 1}`,
        id: `year${year + 1}`,
        // Setting to text for header alignment, will need to update later
        type: ColumnTypes.TEXT
    }));
    const descriptionCol: ColumnDefinition<CashflowRow> = {
        cell: item => <span>{item.description}</span>,
        header: constants.COST_PER_YEAR_HEADER,
        id: 'description',
        type: ColumnTypes.TEXT
    };
    return [descriptionCol, ...yearCols];
}
